(() => {
  const rootSelector = '[data-dmuly-upload-quote]';
  const muralProjects = new Set(['School mural', 'Business / commercial mural', 'Home / personal mural']);
  const muralFields = new Set(['wall_location', 'wall_surface', 'wall_height', 'wall_width', 'special_access', 'preferred_timing']);
  const accessDetailsValues = new Set(['Height / elevated access', 'Stairs / difficult access', 'Unsure']);
  const quoteChoices = {
    'school mural quote': 'School mural',
    'commercial mural quote': 'Business / commercial mural',
    'residential mural quote': 'Home / personal mural'
  };
  let pendingChoice = '';

  const field = (form, name) => form.elements.namedItem(name);

  function update(form) {
    const project = field(form, 'project_type');
    if (!project) return;
    const choice = project.value;
    const mural = muralProjects.has(choice);
    const access = field(form, 'special_access');
    const timing = field(form, 'preferred_timing');

    form.querySelectorAll('.element-group').forEach(group => {
      const controls = Array.from(group.querySelectorAll('input:not([type="hidden"]), select, textarea'));
      if (!controls.length) return;
      const first = controls[0];
      const name = first.name;
      let active = name === 'project_type' || Boolean(choice);
      const dependencyName = group.getAttribute('data-condition');
      const dependency = dependencyName && field(form, dependencyName);
      if (dependency) active = active && dependency.value === group.getAttribute('data-condition-value');
      if (muralFields.has(name)) active = active && mural;
      if (name === 'access_details') active = active && mural && accessDetailsValues.has(access?.value);
      if (name === 'preferred_date') active = active && mural && timing?.value === 'Specific date';
      group.hidden = !active;
      group.style.display = active ? '' : 'none';

      const required = Boolean(group.querySelector('label.required'));
      controls.forEach(control => {
        if (!active && !control.disabled) {
          control.dataset.dmulyDisabled = 'true';
          control.disabled = true;
        } else if (active && control.dataset.dmulyDisabled === 'true') {
          control.disabled = false;
          delete control.dataset.dmulyDisabled;
        }
        control.required = active && required;
        control.setAttribute('aria-required', String(active && required));
        if (!control.id && control.name) control.id = control.name;
        if (control.type === 'file') {
          const tooLarge = Array.from(control.files || []).some(file => file.size > 5 * 1024 * 1024);
          control.setCustomValidity(active && tooLarge ? 'Please choose an image smaller than 5 MB.' : '');
        }
      });
    });

    const submit = form.querySelector('.form-submit-btn-wrap');
    if (submit) submit.hidden = !choice;
  }

  function applyChoice(root, choice) {
    const form = root.querySelector('form.cs-form-wrap');
    const project = form && field(form, 'project_type');
    if (!project || !Array.from(project.options).some(option => option.value === choice)) return false;
    project.value = choice;
    project.dispatchEvent(new Event('change', { bubbles: true }));
    update(form);
    return true;
  }

  function attach(root) {
    if (root.dataset.dmulyObserved === 'true') return;
    root.dataset.dmulyObserved = 'true';
    let observer;

    const initialize = () => {
      const form = root.querySelector('form.cs-form-wrap');
      if (!form || !field(form, 'project_type') || !form.querySelector('button[type="submit"]')) return false;
      if (form.dataset.dmulyReady === 'true') return true;
      form.dataset.dmulyReady = 'true';
      const headings = { name: 'How can I reach you?', wall_location: 'About the wall', event_type: 'About the event', artwork_details: 'About the artwork' };
      Object.entries(headings).forEach(([name, text]) => {
        const group = field(form, name)?.closest('.element-group');
        if (!group) return;
        const heading = document.createElement('h3');
        heading.className = 'dq-ecf__group-heading';
        heading.textContent = text;
        group.prepend(heading);
      });
      const autocomplete = { name: 'name', email: 'email', phone: 'tel' };
      Object.entries(autocomplete).forEach(([name, value]) => {
        const control = field(form, name);
        if (control) control.setAttribute('autocomplete', value);
      });
      const phone = field(form, 'phone');
      if (phone) phone.placeholder = 'Your phone number';

      const blockInvalid = event => {
        update(form);
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          form.reportValidity();
        }
      };
      form.addEventListener('submit', blockInvalid, true);
      form.addEventListener('click', event => {
        const button = event.target.closest('button[type="submit"], input[type="submit"]');
        if (button && button.form === form) blockInvalid(event);
      }, true);
      form.addEventListener('change', event => {
        // Own branch switching in this section so the app does not erase a
        // customer's hidden answers when they change project type.
        if (event.target.matches('.condition-trigger')) event.stopPropagation();
        update(form);
      }, true);
      update(form);
      const loading = root.querySelector('[data-dmuly-form-loading]');
      if (loading) loading.hidden = true;
      if (pendingChoice && applyChoice(root, pendingChoice)) pendingChoice = '';
      root.hidden = false;
      const fallback = document.querySelector('[data-quote-form]')?.closest('.shopify-section');
      if (fallback) {
        fallback.hidden = true;
        fallback.setAttribute('data-dmuly-fallback-hidden', '');
      }
      observer?.disconnect();
      return true;
    };

    if (!initialize()) {
      observer = new MutationObserver(initialize);
      observer.observe(root, { childList: true, subtree: true });
    }
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || link.hash !== '#contact' || link.origin !== location.origin) return;
    const choice = quoteChoices[link.textContent.trim().toLowerCase()];
    const root = document.querySelector(rootSelector);
    if (!choice || !root) return;
    pendingChoice = applyChoice(root, choice) ? '' : choice;
  });
  document.addEventListener('shopify:section:load', () => document.querySelectorAll(rootSelector).forEach(attach));
  document.querySelectorAll(rootSelector).forEach(attach);
})();
